import { render, staticRenderFns } from "./Individuos-y-familias.vue?vue&type=template&id=666d3992&scoped=true&"
import script from "./Individuos-y-familias.vue?vue&type=script&lang=js&"
export * from "./Individuos-y-familias.vue?vue&type=script&lang=js&"
import style0 from "./Individuos-y-familias.vue?vue&type=style&index=0&id=666d3992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666d3992",
  null
  
)

export default component.exports